import { initializeApp, getApp, deleteApp, FirebaseApp } from 'firebase/app';
import { connectAuthEmulator, getAuth, Auth } from 'firebase/auth';
import { connectFunctionsEmulator, getFunctions, Functions } from 'firebase/functions';
import { FirebaseOptionsExt } from '../types/FirebaseOptionsExt';

let app: FirebaseApp | undefined;
let auth: Auth | undefined;
let functions: Functions | undefined;
let functionsUrl: Record<string, string | undefined> = {};
let coachApiBase: string | undefined;

export const initializeFirebase = async (config: FirebaseOptionsExt, environment: string) => {
  try {
    const existingApp = getApp();
    if (existingApp) {
      console.log("[FirebaseConfig] Deleting existing Firebase app to re-initialize");
      await deleteApp(existingApp);
    }
  } catch (e) {
    // No default app exists, which is fine
  }

  try {
    app = initializeApp(config);
    auth = getAuth(app);
    functions = getFunctions(app, "us-central1"); // todo, region come from config

    if (config.functionsUrl) {
      functionsUrl = config.functionsUrl;
    } else {
      throw new Error("functions url is not defined");
    }

    if (config.coachApiBase) {
      coachApiBase = config.coachApiBase;
    }

    console.log("[FirebaseConfig] Initialized for", environment, { functionsDomain: config.functionsDomain });

    // Emulator logic
    if ((window.location.hostname === "localhost" || process.env.NODE_ENV === "dev") || process.env.NODE_ENV === "test") {
      console.log("[FirebaseConfig] Connecting to Emulators");
      connectAuthEmulator(auth, "http://localhost:9099");
      connectFunctionsEmulator(functions, "localhost", 5001);
    }

    return { app, auth, functions };
  } catch (error) {
    console.error("Firebase initialization failed:", error);
    throw error;
  }
};

export const gerUrlForService = (serviceName: string) => {
  if (!functionsUrl[serviceName]) {
    throw new Error(`functions url for service ${serviceName} is not defined`);
  }
  return functionsUrl[serviceName];
}

export const getCoachApiBaseUrl = () => {
  if (!coachApiBase) {
    throw new Error("coach api base url is not defined");
  }
  return coachApiBase;
}

export { auth, functions };